import { v4 } from 'uuid';
import { OPTION_TYPE } from './schemas';
import { Option } from './models';

export const generateBlankOption = () => {
  return [{ id: null, name: 'blank', type: OPTION_TYPE.BLANK }];
};

export const genereteLoadingOption = () => {
  return {
    id: v4(),
    name: OPTION_TYPE.LOADING,
    type: OPTION_TYPE.LOADING,
  } as Option;
};

export const genereteInfinityLoadingOption = () => {
  return {
    id: v4(),
    name: OPTION_TYPE.INFINITE_LOADING,
    type: OPTION_TYPE.INFINITE_LOADING,
  } as Option;
};

export const generateSkeletonOptions = (repeats: number) => {
  return new Array(repeats).fill(0).map(() => genereteLoadingOption());
};

export const generteHintedOption = (options: { name: string; id: string | null }[]) => {
  return options.map(
    (option) =>
      ({
        ...option,
        type: OPTION_TYPE.HINT,
      } as Option),
  );
};

export const generateErrorsOption = (errors: string[]) => {
  return errors.map(
    (errorMsg) =>
      ({
        id: v4(),
        name: errorMsg,
        type: OPTION_TYPE.ERROR,
      } as Option),
  );
};
